import React from "react";
import StarRating from "../../../components/StarRating";

export default function RatingStep({
  sellerName,
  rating,
  onRatingChange,
  comment,
  onCommentChange,
  onSubmit,
  onSkip,
  submitting,
  submitted,
}) {
  return (
    <div className="min-h-screen bg-gray-50 px-5 py-8 flex flex-col justify-center max-w-md mx-auto">
      <div className="bg-white rounded-3xl p-6 border border-gray-100 shadow-sm text-center space-y-4">
        {submitted ? (
          <div className="py-6 space-y-2">
            <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto text-xl font-bold">
              ✓
            </div>
            <h2 className="text-xl font-bold text-gray-900">Thank You!</h2>
            <p className="text-sm text-gray-500">
              Your feedback helps improve Byka service.
            </p>
          </div>
        ) : (
          <>
            <div className="w-12 h-12 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto text-xl font-bold">
              ★
            </div>
            <h2 className="text-xl font-bold text-gray-900">Rate Seller</h2>
            <p className="text-sm text-gray-500">
              How was your experience delivering for{" "}
              {sellerName || "this seller"}?
            </p>

            <div className="flex justify-center py-2">
              <StarRating value={rating} onChange={onRatingChange} size={36} />
            </div>

            {rating > 0 && (
              <textarea
                value={comment}
                onChange={(e) => onCommentChange(e.target.value)}
                placeholder="Optional feedback..."
                rows={2}
                className="w-full border border-gray-200 rounded-xl p-3 text-xs text-gray-700 focus:ring-1 focus:ring-emerald-500 focus:outline-none"
              />
            )}

            <div className="space-y-2 pt-2">
              {rating > 0 && (
                <button
                  onClick={onSubmit}
                  disabled={submitting}
                  className="w-full py-3.5 rounded-xl bg-emerald-500 text-white font-bold text-sm hover:bg-emerald-600 active:scale-95 transition-all disabled:opacity-50"
                >
                  {submitting ? "Submitting..." : "Submit Rating"}
                </button>
              )}
              <button
                onClick={onSkip}
                className="w-full py-3 rounded-xl border border-gray-200 text-gray-600 font-semibold text-sm hover:bg-gray-50 transition-colors"
              >
                Back to Home
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
